import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { BusinessAdminExtractTableHeading } from "../../Utils/appConstants";
import { getExtractionList } from "../../service/api";
import { Box } from "@material-ui/core";
import Loaderpage from "../../pages/LoaderPage";
import BusinessSystemExtractDocument from "../../pages/businessSystemExtractDocument";

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeadFont: {
    fontWeight: 600,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  tableContainerClass: {
    padding: '48px 25% 24px'
  }
});


const BusinessAdminExtractComponent = (props) => {
  const classes = useStyles();
  const [extractionListData, setExtractionListData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(async () => {
    setLoader(true)
    const data = 'Business';
    const extractionList = await getExtractionList(data);
    setExtractionListData(extractionList?.data?.extractList)
    setLoader(false)
  }, []);

  return (
    <div>
      <div className={classes.tableContainerClass}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont} >
               {BusinessAdminExtractTableHeading.map((item) => {
                  return (
                    <TableCell>
                        {item.label}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {extractionListData && extractionListData
                ?.map((row, index) => (
                  <TableRow key={index} className={classes.tableRow} >
                    <TableCell>
                      <span className="textStyle">
                        <BusinessSystemExtractDocument id={row?.extract_id} label={row?.extract_name} />
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
          {loader ? (
            <Box
              height={"350px"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <div>
                <Loaderpage />
                <span className="loaderText">Loading...</span>
              </div>
            </Box>
          ) : (
            ""
          )}
        </div>
      </div>
  );
};

export default BusinessAdminExtractComponent;